import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
}

const SEO: FC<SEOProps> = ({
  title = 'Aluxim | Ogrody zimowe, zabudowy tarasów i balkonów',
  description = 'Profesjonalne ogrody zimowe, zabudowy tarasów i balkonów. Nowoczesne rozwiązania dla Twojego domu od firmy Aluxim z wieloletnim doświadczeniem.',
  keywords = 'ogrody zimowe, zabudowy tarasów, zabudowy balkonów, system bezramowy, zadaszenia tarasów, daszki',
  ogImage = 'https://www.aluxim.pl/og-image.jpg',
  ogType = 'website'
}) => {
  const location = useLocation();
  const canonicalUrl = `https://www.aluxim.pl${location.pathname}`;
  
  useEffect(() => {
    // Update page title
    document.title = title;
    
    // Update meta tags
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update Open Graph tags
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute('content', title);
    }
    
    const ogDescTag = document.querySelector('meta[property="og:description"]');
    if (ogDescTag) {
      ogDescTag.setAttribute('content', description);
    }
    
    const ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      ogUrlTag.setAttribute('content', canonicalUrl);
    }
    
    const ogImageTag = document.querySelector('meta[property="og:image"]');
    if (ogImageTag) {
      ogImageTag.setAttribute('content', ogImage);
    }
    
    const ogTypeTag = document.querySelector('meta[property="og:type"]');
    if (ogTypeTag) {
      ogTypeTag.setAttribute('content', ogType);
    }
    
    // Update Twitter tags
    const twitterTitleTag = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitleTag) {
      twitterTitleTag.setAttribute('content', title);
    }
    
    const twitterDescTag = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescTag) {
      twitterDescTag.setAttribute('content', description);
    }
    
    const twitterUrlTag = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrlTag) {
      twitterUrlTag.setAttribute('content', canonicalUrl);
    }
    
    const twitterImageTag = document.querySelector('meta[property="twitter:image"]');
    if (twitterImageTag) {
      twitterImageTag.setAttribute('content', ogImage);
    }
    
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', canonicalUrl);
    }
  }, [title, description, keywords, canonicalUrl, ogImage, ogType]);
  
  return null;
};

export default SEO;
